export default __webpack_public_path__ + "static/media/everyouthh.b25d227b.jpg";